import { Injectable } from '@angular/core';

import GuideState from '../states/guide.state';

@Injectable({ providedIn: 'root' })
export default class GuideFacade {
  public guidesPerLevel$ = this._state.guidesPerLevel$;
  public selectedGuidePerLevelId$ = this._state.selectedGuidePerLevelId$;

  public updateSelectedGuidePerLevelId = this._state.updateSelectedGuidePerLevelId.bind(this._state);

  public constructor(private readonly _state: GuideState) {}
}
